<div class="lvi-content">
    <div class="avatar" [nSelector]="{ liste: liste, item: data }">
        <i [ngClass]="getIcon()"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ getLibelle() }}</a>
        </div>
    </div>
</div>